const fr: Record<string, string> = {
  'projects.title': 'Projets',
  'projects.subtitle': 'Les projets auxquels je participe.',
  'projects.empty': 'Aucun projet pour le moment.',
  'projects.addProject': 'Ajouter un projet',
  'projects.editProject': 'Modifier le projet',
  'projects.name': 'Nom *',
  'projects.description': 'Description *',
  'projects.creating': 'Création du projet...',
  'projects.updating': 'Modification du projet...',
  'projects.createSuccess': 'Projet créé avec succès.',
  'projects.updateSuccess': 'Projet modifié avec succès.',
  'projects.notFound': 'Projet introuvable',
  'projects.noProjects': 'Aucun projet lié à cette tribu pour le moment.',
  'projects.reorderProjects': 'Ordonner les projets',
  'projects.finishReorderProjects': 'Terminer l\'ordre des projets',
  'projects.moveUp': 'Monter',
  'projects.moveDown': 'Descendre',
  'projects.archivedProjects': 'Projets archivés',
  'projects.reactivate': 'Réactiver',
  'projects.noArchivedProjects': 'Aucun projet archivé.',
  'projects.tabTribes': 'Tribus',
  'projects.noTribesLinked': 'Aucune tribu liée à ce projet.',
  'projects.descriptionOptional': 'Description',
  'projects.features': 'Fonctionnalités',
  'projects.tabsConfig': 'Onglets',
  'projects.archiveTitle': 'Archiver ce projet ?',
  'projects.archiveMessage':
    'Cela va archiver "{{name}}". Il ne sera plus actif.',

  'tribes.title': 'Tribus',
  'tribes.subtitle': 'Les tribus auxquelles je participe.',
  'tribes.createTribe': 'Tribu',
  'tribes.empty': "Aucune tribu pour l'instant. Créez votre première tribu !",
  'tribes.createTitle': 'Créer une nouvelle tribu',
  'tribes.createSubtitle':
    'Remplissez le formulaire ci-dessous pour créer une nouvelle tribu',
  'tribes.updateTitle': 'Modifier la tribu',
  'tribes.updateSubtitle': 'Modifiez les informations de la tribu ci-dessous',
  'tribes.name': 'Nom *',
  'tribes.tribeName': 'Nom de la tribu *',
  'tribes.description': 'Description *',
  'tribes.membersAndPositions': 'Membres et positions',
  'tribes.membersAndPositionsHint':
    'Sélectionnez des personnes et assignez leurs positions. Au moins un Manager est requis.',
  'tribes.filterPersons': 'Filtrer les personnes',
  'tribes.clearAllFilters': 'Effacer tous les filtres',
  'tribes.clearFilters': 'Effacer les filtres',
  'tribes.showOnlySelected':
    'Afficher uniquement les personnes sélectionnées ({{count}})',
  'tribes.showingSelected': '{{count}} personne(s) sélectionnée(s)',
  'tribes.foundPersons': '{{count}} personne(s) correspondant à « {{search}} »',
  'tribes.loadingPersons': 'Chargement des personnes...',
  'tribes.noPersonsAvailable':
    "Aucune personne disponible. Veuillez d'abord créer des personnes.",
  'tribes.noPersonsMatch':
    'Aucune personne ne correspond à votre filtre. Essayez un autre terme.',
  'tribes.noPersonsSelected':
    'Aucune personne sélectionnée. Sélectionnez des personnes dans la liste ci-dessus.',
  'tribes.noPersonsSelectedShort': 'Aucune personne sélectionnée.',
  'tribes.noPersonsFound': 'Aucune personne trouvée.',
  'tribes.creatingTribe': 'Création de la tribu...',
  'tribes.updatingTribe': 'Modification de la tribu...',
  'tribes.createWait':
    "Veuillez patienter pendant la création de la tribu et l'assignation des membres",
  'tribes.updateWait':
    "Veuillez patienter pendant l'enregistrement de vos modifications",
  'tribes.createSuccess': 'Tribu créée avec succès. Redirection en cours...',
  'tribes.updateSuccess': 'Tribu modifiée avec succès !',
  'tribes.noMembers':
    "Aucun membre pour l'instant. Cliquez sur « Modifier la tribu » pour en ajouter.",
  'tribes.membersCount': 'Membres ({{count}})',
  'tribes.tribesCount': 'Tribus ({{count}})',
  'tribes.attachmentsCount': 'Pièces jointes ({{count}})',
  'tribes.download': 'Télécharger',
  'tribes.descriptionSection': 'Description',
  'tribes.as': 'en tant que',
  'tribes.notFound': 'Tribu introuvable',
  'tribes.tabDescription': 'Description',
  'tribes.tabProjects': 'Projets',
  'tribes.tabMembers': 'Membres',
  'tribes.archive': 'Archiver',
  'tribes.archiveConfirmTitle': 'Archiver cette tribu ?',
  'tribes.archiveConfirmMessage':
    "Cette action va archiver \"{{name}}\". Elle n'apparaîtra plus comme active.",

  'positions.manager': 'Manager',
  'positions.member': 'Membre',
  'positions.guest': 'Invité',

  'projectDocuments.tab': 'Documents',
  'projectDocuments.addDocument': 'Document',
  'projectDocuments.newDocument': 'Document',
  'projectDocuments.searchPlaceholder': 'Rechercher des documents...',
  'projectDocuments.allLabels': 'Tous',
  'projectDocuments.noDocuments': "Aucun document pour l'instant.",
  'projectDocuments.noResults':
    'Aucun document ne correspond à votre recherche.',
  'projectDocuments.title': 'Titre',
  'projectDocuments.titlePlaceholder': 'Titre du document...',
  'projectDocuments.titleRequired': 'Le titre est requis',
  'projectDocuments.labels': 'Étiquettes',
  'projectDocuments.labelsPlaceholder': 'Ajouter des étiquettes...',
  'projectDocuments.creating': 'Création du document...',
  'projectDocuments.updating': 'Mise à jour du document...',
  'projectDocuments.notFound': 'Document introuvable',
  'projectDocuments.backToProject': 'Retour au projet',
  'projectDocuments.backToDocuments': 'Retour aux documents',
  'projectDocuments.archiveTitle': 'Archiver ce document ?',
  'projectDocuments.archiveMessage':
    "Ce document \"{{title}}\" sera archivé et n'apparaîtra plus dans la liste.",
  'projectDocuments.tocDepthLabel':
    'Profondeur de la table des matières (mode lecture)',

  'documentPages.pages': 'Pages',
  'documentPages.addPage': 'Page',
  'documentPages.newPage': 'Nouvelle page',
  'documentPages.noPages': "Aucune page pour l'instant.",
  'documentPages.title': 'Titre',
  'documentPages.titlePlaceholder': 'Titre de la page...',
  'documentPages.titleRequired': 'Le titre est requis',
  'documentPages.creating': 'Création de la page...',
  'documentPages.updating': 'Mise à jour de la page...',
  'documentPages.notFound': 'Page introuvable',
  'documentPages.archiveTitle': 'Archiver cette page ?',
  'documentPages.archiveMessage':
    "Cette page \"{{title}}\" sera archivée et n'apparaîtra plus dans la liste.",
  'documentPages.read': 'Lire',
  'documentPages.exitRead': 'Quitter le mode lecture',
  'documentPages.pageOf': 'Page {{index}}',
  'documentPages.tableOfContents': 'Table des matières',

  'publications.title': 'Publications',
  'publications.searchPlaceholder': 'Rechercher des publications...',
  'publications.noResults': 'Aucune publication trouvée.',
  'publications.publishedOn': 'Publié le',
  'publications.backToList': 'Retour aux publications',
  'publications.notFound': 'Publication introuvable.',
  'publications.published': 'Publié',
  'publications.publish': 'Publier',
  'publications.unpublish': 'Dépublier',
  'publications.view': 'Voir la page publique',
  'publications.publishConfirmTitle': 'Publier ce document ?',
  'publications.publishConfirmMessage':
    '« {{title}} » sera accessible publiquement sans authentification.',
  'publications.unpublishConfirmTitle': 'Dépublier ce document ?',
  'publications.unpublishConfirmMessage':
    '« {{title}} » ne sera plus accessible publiquement.',
  'publications.allTribes': 'Toutes les tribus',
  'publications.allProjects': 'Tous les projets',
  'publications.author': 'Écrit par',

  'validation.tribeNameRequired': 'Le nom de la tribu est requis',
  'validation.documentContentRequired': 'Le contenu du document est requis',
  'validation.selectOnePerson':
    'Veuillez sélectionner au moins une personne pour la tribu',
  'validation.assignOneChief':
    'Veuillez désigner au moins une personne comme Chef',
  'validation.noChanges': 'Aucune modification détectée',
  'validation.failedCreateTribe':
    "Une erreur s'est produite lors de la création de la tribu",
  'validation.failedUpdateTribe': 'Échec de la mise à jour de la tribu',
};

export default fr;
